export enum AccentColors {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Success = 'Success',
  Danger = 'Danger',
  Muted = 'Muted',
  Info = 'info',
  Warning = 'Warning',
}

export enum Sizes {
  Large = 'Large',
}

export enum PaymentGateways {
  Saman = 'Saman',
  Melli = 'Melli',
  ZarinPal = 'ZarinPal',
}

export enum TableControlDatePickerNames {
  From = 'From',
  To = 'To',
}

export enum Layouts {
  Panel = 'Panel',
  Auth = 'Auth',
  Verify = 'Verify',
}

export enum RouteNames {
  Stats = 'Stats',
  Channels = 'Channels',
  NewChannel = 'NewChannel',
  EditChannel = 'EditChannel',
  SignUp = 'SignUp',
  SignIn = 'SignIn',
  Services = 'Services',
  Service = 'Service',
  Connections = 'connections',
  Sessions = 'Sessions',
  Session = 'Session',
  Files = 'Files',
  Users = 'Users',
  User = 'User',
  NewUser = 'NewUser',
  EditUser = 'EditUser',
  Profile = 'Profile',
  EditFile = 'EditFile',
  NewFile = 'NewFile',
  Notifications = 'Notifications',
  ForgetPassword = 'ForgetPassword',
  Recordings = 'Recordings',
  Recording = 'Recording',
  Records = 'Records',
  Invoices = 'Invoices',
  Invoice = 'Invoice',
  Support = 'Support',
  EditTicket = 'EditTicket',
  NewTicket = 'NewTicket',
  NewOrder = 'NewOrder',
  Help = 'Help',
  Settings = 'Settings',
  SettingFileUpload = 'SettingFileUpload',
  SettingAccessManagement = 'SettingAccessManagement',
  SettingAccessManagementAccountDetail = 'SettingAccessManagementAccountDetail',
  SettingSecurity = 'SettingSecurity',
  SettingBackupLogs = 'SettingBackupLogs',
  SettingPasswordManagement = 'SettingPasswordManagement',
  SettingActiveSessions = 'SettingActiveSessions',
  LogsLoginLogReport = 'LogsLoginLogReport',
  LogsActivity = 'LogsActivity',
  LogsProductVersion = 'LogsProductVersion',
  LogsSystemStatus = 'LogsSystemStatus',
  EventsDashboard = 'EventsDashboard',
  EventsMembers = 'EventsMembers',
  Verify = 'Verify',
}

export enum RootRouteNames {
  Root = 'Root',
  RootRooms = 'RootRooms',
  RootServices = 'RootServices',
  RootFinancial = 'RootFinancial',
  RootSupport = 'RootSupport',
  RootSettings = 'RootSettings',
  RootEvents = 'RootEvents',
  RootLogs = 'RootLogs',
}

export enum RouteModes {
  New = 'New',
  Edit = 'Edit',
}

export enum ApiMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

export enum FileType {
  OTHER = 0,
  SLIDE = 1,
  SOUND = 2,
  VIDEO = 3,
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export interface ListQueryParams {
  selectedId?: number;
  sortOrder?: SortOrder.Asc | SortOrder.Desc;
  sortBy?: string;
  page?: number;
  pageSize?: number;
  search?: string;
}

export enum ServiceExpiredType {
  EXPIRED = 'expired',
  POTENTIAL = 'potential',
  ALIVE = 'alive',
}

export enum TimeFormat {
  HMS = 'hh:mm:ss',
  HM = 'hh:mm',
}

export enum ErrorCodes {
  RECORDING_FILE_NOT_FOUND = 'RECORDING_FILE_NOT_FOUND',
  GET_RECORDING_FILES_FAILED = 'GET_RECORDING_FILES_FAILED',
  UPDATE_RECORDING_FAILED = 'UPDATE_RECORDING_FAILED',
  TOKEN_NOT_FOUND_IN_DATABASE = 'TOKEN_NOT_FOUND_IN_DATABASE',
  CHANNEL_NOT_FOUND = 'CHANNEL_NOT_FOUND',
  CHANNEL_MAXIMUM_LIMIT_REACHED = 'CHANNEL_MAXIMUM_LIMIT_REACHED',
  CHANNEL_NAME_DUPLICATED = 'CHANNEL_NAME_DUPLICATED',
  CHANNEL_IMPORT_ROOM_NAME_ERROR = 'CHANNEL_IMPORT_ROOM_NAME_ERROR',
  CHANNEL_IMPORT_NAME_DUPLICATED = 'CHANNEL_IMPORT_NAME_DUPLICATED',
  CHANNEL_IMPORT_REMAINING_CAPACITY = 'CHANNEL_IMPORT_REMAINING_CAPACITY',
  CHANNEL_IMPORT_MAXIMUM_LIMIT_REACHED = 'CHANNEL_IMPORT_MAXIMUM_LIMIT_REACHED',
  CHANNEL_USER_ID_DUPLICATED = 'CHANNEL_USER_ID_DUPLICATED',
  CONNECTION_NOT_FOUND = 'CONNECTION_NOT_FOUND',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FILE_NOT_FOUND_MULTIPLE = 'FILE_NOT_FOUND_MULTIPLE',
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  USER_DEACTIVATED = 'USER_DEACTIVATED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  NOTIFICATION_NOT_FOUND = 'NOTIFICATION_NOT_FOUND',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  RESERVE_ORDER_NOT_FOUND = 'RESERVE_ORDER_NOT_FOUND',
  ORDER_HAS_NO_PLAN = 'ORDER_HAS_NO_PLAN',
  PLAN_NOT_FOUND = 'PLAN_NOT_FOUND',
  PROVINCE_NOT_FOUND = 'PROVINCE_NOT_FOUND',
  CITY_NOT_FOUND = 'CITY_NOT_FOUND',
  CANNOT_CHANGE_CUSTOMER_TYPE = 'CANNOT_CHANGE_CUSTOMER_TYPE',
  CANNOT_CHANGE_FIRSTNAME = 'CANNOT_CHANGE_FIRSTNAME',
  CANNOT_CHANGE_LASTNAME = 'CANNOT_CHANGE_LASTNAME',
  INVALID_BIRTHDATE = 'INVALID_BIRTHDATE',
  SERVICE_NOT_FOUND = 'SERVICE_NOT_FOUND',
  ACTIVATION_DEADLINE_TIME_EXPIRED = 'ACTIVATION_DEADLINE_TIME_EXPIRED',
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  SESSION_NOT_FOUND = 'SESSION_NOT_FOUND',
  USER_NOT_FOUND_MULTIPLE = 'USER_NOT_FOUND_MULTIPLE',
  USER_MAXIMUM_LIMIT_REACHED = 'USER_MAXIMUM_LIMIT_REACHED',
  USERNAME_SAME_AS_CUSTOMER = 'USERNAME_SAME_AS_CUSTOMER',
  USER_INVALID_EMAIL_DOMAIN = 'USER_INVALID_EMAIL_DOMAIN',
  USER_PASSWORD_TOO_SHORT = 'USER_PASSWORD_TOO_SHORT',
  SAME_USERNAME_EXISTS_FOR_CUSTOMER = 'SAME_USERNAME_EXISTS_FOR_CUSTOMER',
  CHANNEL_NOT_FOUND_MULTIPLE = 'CHANNEL_NOT_FOUND_MULTIPLE',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  PASSWORD_TOO_SIMPLE = 'PASSWORD_TOO_SIMPLE',
  USER_DISABLED = 'USER_DISABLED',
  USER_STATUS_IS_DEACTIVE = 'USER_STATUS_IS_DEACTIVE',
  USER_IMPORT_LIMIT_EXCEEDED = 'USER_IMPORT_LIMIT_EXCEEDED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  REGISTRATION_ERROR_INCORRECT_OTP_CODE = 'REGISTRATION_ERROR_INCORRECT_OTP_CODE',
  AUTH_ERROR_INVALID_CAPTCHA = 'AUTH_ERROR_INVALID_CAPTCHA',
  LOGIN_INVALID_CREDENTIALS = 'LOGIN_INVALID_CREDENTIALS',
  LOGIN_ERROR_INVALID_CAPTCHA = 'LOGIN_ERROR_INVALID_CAPTCHA',
  LOGIN_SERVICE_IS_UNAVAILABLE = 'LOGIN_SERVICE_IS_UNAVAILABLE',
  REGISTRATION_ERROR_INVALID_OLD_PASSWORD = 'REGISTRATION_ERROR_INVALID_OLD_PASSWORD',
  REGISTRATION_ERROR_TOKEN_HAS_EXPIRED = 'REGISTRATION_ERROR_TOKEN_HAS_EXPIRED',
  REGISTRATION_ERROR_INVALID_TOKEN = 'REGISTRATION_ERROR_INVALID_TOKEN',
  REGISTRATION_ERROR_SERVICE_IS_UNAVAILABLE = 'REGISTRATION_ERROR_SERVICE_IS_UNAVAILABLE',
  REGISTRATION_ERROR_INVALID_MOBILE_NUMBER = 'REGISTRATION_ERROR_INVALID_MOBILE_NUMBER',
  REGISTRATION_ERROR_INVALID_USERNAME = 'REGISTRATION_ERROR_INVALID_USERNAME',
  REGISTRATION_ERROR_INVALID_PASSWORD = 'REGISTRATION_ERROR_INVALID_PASSWORD',
  REGISTRATION_ERROR_INVALID_REPEAT_PASSWORD = 'REGISTRATION_ERROR_INVALID_REPEAT_PASSWORD',
  REGISTRATION_ERROR_INVALID_CAPTCHA = 'REGISTRATION_ERROR_INVALID_CAPTCHA',
  REGISTRATION_TOKEN_HAS_EXPIRED = 'REGISTRATION_TOKEN_HAS_EXPIRED',
  REGISTRATION_INVALID_TOKEN = 'REGISTRATION_INVALID_TOKEN',
  REGISTRATION_IS_DISABLED = 'REGISTRATION_IS_DISABLED',
  REGISTRATION_ERROR_USER_DOES_NOT_EXISTS = 'REGISTRATION_ERROR_USER_DOES_NOT_EXISTS',
  REGISTRATION_ERROR_MOBILE_NUMBER_ALREADY_EXISTS = 'REGISTRATION_ERROR_MOBILE_NUMBER_ALREADY_EXISTS',
  REGISTRATION_ERROR_USERNAME_ALREADY_EXISTS = 'REGISTRATION_ERROR_USERNAME_ALREADY_EXISTS',
  REGISTRATION_SERVICE_IS_UNAVAILABLE = 'REGISTRATION_SERVICE_IS_UNAVAILABLE',
  INCOMPLETE_PROFILE_INFORMATION = 'INCOMPLETE_PROFILE_INFORMATION',
  EMAIL_ADDRESS_IS_EXISTS = 'EMAIL_ADDRESS_IS_EXISTS',
  INVALID_NATIONAL_ID = 'INVALID_NATIONAL_ID',
  INVALID_NATIONAL_CODE = 'INVALID_NATIONAL_CODE',
  COUPON_APPLY_FAILED = 'COUPON_APPLY_FAILED',
  INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND',
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  // Payment service codes
  INVOICE = 'INVOICE',
  'EXPIRE-INVOICE' = 'EXPIRE-INVOICE',
  // not an actual error coming from server, custom unknown error for payment
  'EXPIRE-INVOICE-RENEW' = 'EXPIRE-INVOICE-RENEW',
  'HITS-COUPON' = 'HITS-COUPON',
  'GATEWAY' = 'GATEWAY',
  'GATEWAY-CONNECT' = 'GATEWAY-CONNECT',
  'PAYMENT-VERIFY' = 'PAYMENT-VERIFY',
  'PAYMENT-INFORMATION' = 'PAYMENT-INFORMATION',
  'PAYMENT-STATUS' = 'PAYMENT-STATUS',
  // not an actual error coming from server, custom unknown error for payment
  'PAYMENT-UNKNOWN-ERROR' = 'PAYMENT-UNKNOWN-ERROR',
  INVOICE_SERVICE_IS_NOT_AVAILABLE = 'INVOICE_SERVICE_IS_NOT_AVAILABLE',
  INVOICE_IS_NOT_PAID = 'INVOICE_IS_NOT_PAID',
  INVOICE_IS_PAID = 'INVOICE_IS_PAID',
  INVOICE_COUPON_USAGE_DISABLED = 'INVOICE_COUPON_USAGE_DISABLED',
  INVOICE_ALREADY_HAS_COUPON = 'INVOICE_ALREADY_HAS_COUPON',
  COUPON_IS_NOT_FOR_THIS_INVOICE = 'COUPON_IS_NOT_FOR_THIS_INVOICE',
  COUPON_IS_JUST_FOR_FIRST_INVOICE = 'COUPON_IS_JUST_FOR_FIRST_INVOICE',
  COUPON_IS_NOT_ACTIVE = 'COUPON_IS_NOT_ACTIVE',
  COUPON_MAX_USAGE_REACHED = 'COUPON_MAX_USAGE_REACHED',
  COUPON_NOT_STARTED = 'COUPON_NOT_STARTED',
  COUPON_EXPIRED = 'COUPON_EXPIRED',
  COUPON_ALREADY_USED = 'COUPON_ALREADY_USED',
  COUPON_REMOVED = 'COUPON_REMOVED',
  COUPON_REMOVING_FAILED = 'COUPON_REMOVING_FAILED',
  FILE_SERVICE_IS_NOT_AVAILABLE = 'FILE_SERVICE_IS_NOT_AVAILABLE',
  FILE_SERVICE_MISCONFIGURED = 'FILE_SERVICE_MISCONFIGURED',
  USER_INVALID_INFO = 'USER_INVALID_INFO',
  AUTH_ERROR_OTP_TOO_MANY_ATTEMPTS = 'AUTH_ERROR_OTP_TOO_MANY_ATTEMPTS',
  RECOVERY_PASSWORD_ERROR_INVALID_PASSWORD = 'RECOVERY_PASSWORD_ERROR_INVALID_PASSWORD',
  SKYROOM_AUTH_ERR_USER_LOCKED_OUT = 'SKYROOM_AUTH_ERR_USER_LOCKED_OUT',
  REGISTRATION_ERROR_HAVE_EXTRA_ACCOUNT = 'REGISTRATION_ERROR_HAVE_EXTRA_ACCOUNT',
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
  LOGIN_USER_DISABLED = 'LOGIN_USER_DISABLED',
  REFRESH_TOKEN_ERROR_NOT_FOUND = 'REFRESH_TOKEN_ERROR_NOT_FOUND',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  CSRF_TOKEN_INVALID = 'CSRF_TOKEN_INVALID',
}
